let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("99Uum")).then(() => parcelRequire('ecCqM'));